<!-- 翻车机作业环节明细 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menu: false,
        column: [
          {
            label: '运输记录ID',
            prop: 'transportRecordId',
            search: true,
            overHidden: true,
            minWidth: 120
          },
          {
            label: '计划编号',
            prop: 'planNo',
            search: true,
            overHidden: true,
            minWidth: 130
          },
          {
            label: '车次编号',
            prop: 'trainNumber',
            search: true,
            overHidden: true,
            minWidth: 120
          },
          {
            label: '阶段序号',
            prop: 'phaseOrder',
            type: 'number',
            width: 90
          },
          {
            label: '阶段名称',
            prop: 'phaseName',
            search: true,
            overHidden: true,
            minWidth: 140
          },
          {
            label: '开始点位',
            prop: 'startPointName',
            overHidden: true,
            minWidth: 160
          },
          {
            label: '结束点位',
            prop: 'endPointName',
            overHidden: true,
            minWidth: 160
          },
          {
            label: '开始时间',
            prop: 'startTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            minWidth: 170
          },
          {
            label: '结束时间',
            prop: 'endTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            minWidth: 170
          },
          {
            label: '环节耗时(秒)',
            prop: 'durationSeconds',
            type: 'number',
            width: 120
          },
          {
            label: '是否正常',
            prop: 'isNormal',
            type: 'select',
            overHidden: true,
            width: 100,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_normal",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            }
          },
          {
            label: '缺失点位',
            prop: 'missingPointNames',
            overHidden: true,
            minWidth: 180
          },
          {
            label: '异常原因',
            prop: 'abnormalReason',
            overHidden: true,
            minWidth: 180
          },
          {
            label: '数据来源',
            prop: 'dataSource',
            overHidden: true,
            width: 100
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"]
          },
        ]
      },
    }
  }
}
</script>
<style scoped lang="scss">
</style>
